/* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */

import useAuth from 'hooks/auth/useAuth';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { ehModelTypeState, userSubLevelState } from 'states';
import { EhModelType, ProductType, SubLevel } from 'types';

const useSynthOi = () => {
  const ehModelType = useRecoilValue(ehModelTypeState);
  const userLevel = useRecoilValue(userSubLevelState);
  const { hasAccessToProduct } = useAuth();
  const [searchParams] = useSearchParams();

  const currentEhModelType = useMemo(() => {
    return searchParams.get('eh-model') ?? ehModelType;
  }, [searchParams, ehModelType]);

  const hasSynthOiAccess = useMemo(() => {
    return (
      hasAccessToProduct(ProductType.EQUITYHUB) && userLevel > SubLevel.PRO
    );
  }, [hasAccessToProduct, userLevel]);

  return {
    isSynthOI: hasSynthOiAccess && currentEhModelType === EhModelType.SynthOI,
    hasSynthOiAccess,
  };
};

export default useSynthOi;
